import { getData } from '../get-table'
import { HttpService } from '../http.service'

const http = new HttpService()

export interface Entity {
  id?: string
  name: string
  code: string
  countryId: string
  typeId: string
}

export async function getEntities(
  offset: number,
  perPage: number,
  dataOrder: string,
  search: string = ''
): Promise<any> {
  // where's
  const where = ['country_id = :countryId']
  if (search) {
    where.push(
      `CONCAT(entity_types.name, entities.name, entities.code) ILIKE '%${search}%'`
    )
  }
  // order by
  let modifier = []
  dataOrder !== ''
    ? dataOrder[1] === 'code'
      ? (modifier = [
          `ORDER BY (CASE WHEN entities.code ~ '^[0-9]+$' THEN CAST(entities.code AS NUMERIC) ELSE NULL END) ${dataOrder[0]}, entities.code ${dataOrder[0]}`
        ])
      : (modifier = [`order by ${dataOrder[1]} ${dataOrder[0]}`])
    : (modifier = [
        "ORDER BY (CASE WHEN entities.code ~ '^[0-9]+$' THEN CAST(entities.code AS numeric) ELSE NULL END), entities.code"
      ])
  // result
  const response: any = await getData({
    tables: ['pg_entities'],
    fields: [
      'entities.id',
      'entities.name',
      'entities.code',
      'entity_types.name as entity_type',
      'entities.updated_at'
    ],
    join: ['INNER JOIN entity_types ON entities.type_id = entity_types.id'],
    where,
    modifier,
    options: {
      outputFormat: 'json',
      pagination: { offset, limit: perPage }
    }
  })
  return response[0]
}

export async function getEntityModel(id: string): Promise<Entity> {
  const data = await getData<any>({
    tables: ['pg_entities'],
    fields: [
      'id',
      'name',
      'code',
      'country_id',
      'type_id as typeId'
      /*'custom_fields as custom'*/
    ],
    where: [`id = '${id}'`],
    options: {
      outputFormat: 'json',
      pagination: { offset: 0, limit: 10 }
    }
  })
  return data[0].results[0]
}

export async function createEntity(data: Entity): Promise<boolean> {
  const response: any = await http.post('country/entities', {
    countryId: data.countryId,
    typeId: data.typeId,
    name: data.name,
    code: data.code
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function updateEntity(data: Entity, id: string): Promise<boolean> {
  const response: any = await http.put('country/entities/' + id, {
    countryId: data.countryId,
    typeId: data.typeId,
    name: data.name,
    code: data.code
  })

  if (response?.data?.data?.error) {
    return false
  }
  return true
}

export async function deleteEntity(id: string): Promise<boolean> {
  const response: any = await http.delete('country/entities/' + id)

  if (response?.data?.data?.error) {
    return false
  }
  return true
}
